var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncidentresponse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "55px",
    viewBox: "0 0 69.0 55.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561,0 L1561,1080 L0,1080 L0,0 L1561,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-44.2622951%",
    y: "-57.4468085%",
    filterUnits: "userSpaceOnUse",
    width: "159.016393%",
    height: "176.595745%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 4.5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6832202,0 L14.6832202,2.12629768 L3.14744643,2.12629768 C2.57022262,2.12629768 2.09761508,2.60304957 2.09761508,3.18356465 L2.09761508,14.8919551 C2.09761508,15.476155 2.5758621,15.9647052 3.14710516,15.9809669 L6.02187698,15.9809669 C6.60110575,15.9809669 7.07068452,16.4570441 7.07068452,17.0442887 L7.07068452,20.0518296 L10.8089544,16.2604424 C11.0055855,16.0610901 11.2725353,15.949248 11.5504825,15.949248 L26.0408,15.949248 C25.6085476,17.1872096 24.4393913,18.0755457 23.0720083,18.0755457 L11.9714048,18.0755543 L6.76337103,23.369501 C6.10249345,24.0395244 4.97306944,23.5651339 4.97306944,22.6177109 L4.97306944,18.1076106 L3.11877976,18.1076106 C1.392125,18.0596309 0,16.6374879 0,14.8919551 L0,3.18356465 C0,1.4262681 1.41439286,0 3.14744643,0 L14.6832202,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82901657,7.2793475 C2.66584435,7.2793475 3.0477765,7.66627105 3.0477765,8.4849588 L3.0477765,8.72316608 C3.0477765,9.54181923 2.66586142,9.92903688 1.82901657,9.92903688 L1.49141538,9.92903688 C0.698594353,9.92903688 0.30200467,9.54185383 0.30200467,8.72316608 L0.30200467,8.4849588 C0.30200467,7.6662278 0.683902686,7.2793475 1.49141538,7.2793475 Z M1.82900378,0 C2.95946866,0 3.57634802,0.714647768 3.29740259,1.81611529 L2.54854564,5.70143948 C2.38691171,6.31164073 2.19594564,6.59444645 1.7996887,6.59444645 L1.52068354,6.59444645 C1.15341747,6.59444645 0.977450206,6.31165803 0.815816277,5.70143948 L0.0669593328,1.81611529 C-0.211943445,0.714621819 0.404901793,0 1.46207044,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0721448,0 C24.8051131,0 26.2195913,1.4261816 26.2195913,3.18356465 L26.2195913,15.9558824 C26.2195913,17.7014152 24.8275516,19.1231854 23.1008115,19.1711919 L21.2465218,19.1711919 L21.2460952,23.6812663 C21.2460952,24.6286806 20.1166627,25.103123 19.4557937,24.4333937 L14.2477599,19.1394471 L3.14710516,19.1394471 C1.41439286,19.1394471 0,17.7132655 0,15.9558824 L0,3.18356465 C0,1.42592211 1.41038294,0 3.14710516,0 L23.0721448,0 Z M23.0718377,2.12679072 L3.14667857,2.12679072 C2.56711706,2.12679072 2.09718849,2.60185589 2.09718849,3.18371169 L2.09718849,15.9560295 C2.09718849,16.5361726 2.56977044,17.0129504 3.14667857,17.0129504 L14.6688016,17.0129504 C14.9467488,17.0129504 15.2136986,17.1247926 15.4103298,17.3244822 L19.1485996,21.1158694 L19.1485996,18.108069 C19.1485996,17.5208244 19.6181784,17.0447472 20.1974071,17.0447472 L23.072179,17.0447472 C23.643405,17.028867 24.121669,16.5402899 24.121669,15.9560814 L24.121669,3.18376359 C24.121669,2.60362046 23.6490871,2.12679072 23.0718377,2.12679072 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8296429,0 L17.8296429,2.12664367 L0,2.12664367 L0,0 L17.8296429,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43867063,0 L9.43867063,2.12664367 L0,2.12664367 L0,0 L9.43867063,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8296429,0 L17.8296429,2.12664367 L0,2.12664367 L0,0 L17.8296429,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-296.0 -829.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.0 842.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 5.316808129103837)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.0408,0 26.0408,23.6831919 0,23.6831919 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.671871817975791 9.081415491361671)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.22044605e-16,0 3.36406654,0 3.36406654,9.92903688 -2.22044605e-16,9.92903688 -2.22044605e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.78040873015872 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.2195913,0 26.2195913,24.7468691 0,24.7468691 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.97580952380956 4.252915404602733)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.8296429,0 17.8296429,2.12664367 0,2.12664367 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.97580952380956 12.75914410532767)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 9.43867063,0 9.43867063,2.12664367 0,2.12664367 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.97580952380956 8.506029754965201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.8296429,0 17.8296429,2.12664367 0,2.12664367 0,0",
    stroke: "none",
    fill: "#55BAB0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentresponse);
export default __webpack_public_path__ + "static/media/incidentresponse.71db4c58daa403f1d81401a8f0173e99.svg";
export { ForwardRef as ReactComponent };